import {usePages} from "../api/pageapi";
import {BasePageLayout} from "../components/grouping/BasePageLayout";

export function BondsdokterPage(props) {
    const {pages} = usePages();


    console.log(pages)
    return <BasePageLayout>
        <div dangerouslySetInnerHTML={{__html: pages ? pages[4]?.htmlFragment?.html : ""}}>

        </div>
    </BasePageLayout>
}